import { Overflow as OverflowElement, type OverflowProps } from "./Overflow";
import { OverflowText, type OverflowTextProps } from "./OverflowText";

/**
 * Overflow component for handling content that exceeds container boundaries.
 *
 * Features:
 * - Supports both horizontal and vertical overflow
 * - Automatic shadow indicators for scrollable content
 * - Truncation with expand/collapse functionality
 * - Keyboard navigation support for focusable elements
 * - Automatic height and width management
 * - Layout utility props support
 * - Resize observer for dynamic content changes
 * - Accessibility features with proper focus management
 * - Scroll event handling with shadow updates
 *
 * @example
 * <Overflow direction="column" height={400} gap="4">
 *   {items.map((item, i) => (
 *     <Card key={i} style={{ width: "100%", minHeight: 100 }}>
 *       {item.content}
 *     </Card>
 *   ))}
 * </Overflow>
 */
export const Overflow = Object.assign(OverflowElement, {
  Text: OverflowText,
});

export default Overflow;

export { type OverflowProps };
export { OverflowText, type OverflowTextProps };
